/** CAD Inversify 容器使用的绑定键集合 */
export const TYPES = {
  /** CAD 基础模块 */
  EntityDetector: Symbol.for('EntityDetector'),
  EntitySelector: Symbol.for('EntitySelector'),
  CADViewManager: Symbol.for('CADViewManager'),
  HistoryManager: Symbol.for('HistoryManager'),
  CADDefaultTool: Symbol.for('CADDefaultTool'),

  /** 控制器 */
  CADController: Symbol.for('CADController'),

  /** CAD绘制 */
  DrawPolylineTool: Symbol.for('DrawPolylineTool'),
  DrawCircleTool: Symbol.for('DrawCircleTool'),
  DrawRectTool: Symbol.for('DrawRectTool'),
  DrawSplineTool: Symbol.for('DrawSplineTool'),
  DrawArcTool: Symbol.for('DrawArcTool'),
  DrawTextTool: Symbol.for('DrawTextTool'),
  DrawDimensionTool: Symbol.for('DrawDimensionTool'),
  DrawPolygonTool: Symbol.for('DrawPolygonTool'),
  DrawEllipseTool: Symbol.for('DrawEllipseTool'),
  DrawRayTool: Symbol.for('DrawRayTool'),
  DrawHatchTool: Symbol.for('DrawHatchTool'),
  DrawMLeaderTool: Symbol.for('DrawMLeaderTool'),
  DrawAngularDimensionTool: Symbol.for('DrawAngularDimensionTool'),

  /** CAD编辑 */
  MoveEntityTool: Symbol.for('MoveEntityTool'),
  CopyEntityTool: Symbol.for('CopyEntityTool'),
  JoinEntityTool: Symbol.for('JoinEntityTool'),
  CloseEntityTool: Symbol.for('CloseEntityTool'),
  RotateEntityTool: Symbol.for('RotateEntityTool'),
  OffsetEntityTool: Symbol.for('OffsetEntityTool'),
  BreakEntityTool: Symbol.for('BreakEntityTool'),
  TrimEntityTool: Symbol.for('TrimEntityTool'),
  ExtendEntityTool: Symbol.for('ExtendEntityTool'),

  /** CAD辅助工具 */
  RenderInvalidator: Symbol.for('RenderInvalidator'),
  MouseTipHelper: Symbol.for('MouseTipHelper'),
  CadI18nService: Symbol.for('CadI18nService'),
  OrthogonalHelper: Symbol.for('OrthogonalHelper'),
  CaptureHelper: Symbol.for('CaptureHelper'),
  GridHelper: Symbol.for('GridHelper'),
  PolarHelper: Symbol.for('PolarHelper'),
  PointCloudHelper: Symbol.for('PointCloudHelper'),
  AuxiliaryMouseHelper: Symbol.for('AuxiliaryMouseHelper'),

  /** 桥接引擎服务（由 createCadContainer 绑定） */
  EngineContext: Symbol.for('EngineContext'),
  Scene: Symbol.for('Scene'),
  Camera: Symbol.for('Camera'),
  Renderer: Symbol.for('Renderer'),
  SelectionService: Symbol.for('SelectionService'),
  PickingService: Symbol.for('PickingService'),
  UnitPresentationService: Symbol.for('UnitPresentationService'),
}
